export enum InsuranceTypes {
  ONE = '1y',
  TWO = '2y',
}
